import { CjsToast, ToastOptions, ToastPlacement } from "./../toast";

/** ToastService key */
export const TOAST_SERVICE = "ToastService";

export interface ToastService {

    /** Current displayed toasts in application */
    displayedToasts: Map<number, CjsToast>;

    /** Container for stacking toasts */
    toastStackingContainer: HTMLElement;

    /** Placement of toasts in app window */
    toastStackingContainerPlacement: ToastPlacement;

    /**
     * Show a toast
     * @returns new toast displayed
     */
    show(toastOrOptions: CjsToast | Partial<ToastOptions>): CjsToast;

    /** 
     * Get a toast displayed with his id
     */
    getToastById(id: number): CjsToast | undefined;

    /** 
     * Hide a toast displayed
     */
    hide(id: number): void;

    /**
     * Hide all toast displayed
     */
    hideAll(): void;
}